import React from 'react';
import './InlineErrorBoundary.css';

class InlineErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Capture the error object here so render() can show Technical Details.
    // Do NOT call setState inside componentDidCatch — that triggers an extra
    // render and can cause crash loops.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    if (process.env.NODE_ENV !== 'production') {
      console.error('Error caught by inline boundary:', error, errorInfo);
    }
  }

  render() {
    return (
      <>
        {this.state.hasError && (
          <div className="inline-error-boundary">
            <div className="inline-error-content">
              <h4>⚠️ Component Error</h4>
              <p>This component encountered an error but is still displayed below.</p>
              {this.state.error && (
                <details className="inline-error-details">
                  <summary>Technical Details</summary>
                  <pre className="inline-error-stack">
                    {this.state.error.toString()}
                    {this.state.errorInfo && this.state.errorInfo.componentStack}
                  </pre>
                </details>
              )}
              <button 
                onClick={() => window.location.reload()} 
                className="inline-error-reload-button"
              >
                Reload Page
              </button>
            </div>
          </div>
        )}
        {this.props.children}
      </>
    );
  }
}

export default InlineErrorBoundary; 